// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AlternateApproverSelect_wrapper__tFRE_"};